import { autoinject, transient } from "aurelia-framework";
import { BaseActivityConfiguration } from "../base-activity-configuration";
import { WorkflowConfigurationService } from "../../../../services/workflow/workflow-configuration-service";
import { AllEntityTypeConfigurationConstants } from "../../../../models/basics/basics.models";

@autoinject()
@transient()
export class ReassignActivityConfiguration extends BaseActivityConfiguration {

    views: { folder: string, view: string }[] = [];

    constructor(workflowConfigurationService: WorkflowConfigurationService) {
        super(workflowConfigurationService);
    }

    onActivated() {
        const entityTypeId = AllEntityTypeConfigurationConstants.filter(x => x.uri == this.entity)[0].entityType;
        this.workflowConfigurationService.getActivityMetadata<{ folder: string, view: string }[]>(entityTypeId, 'reassign-activity', this.branchId).then(views => {
            this.views = views;
        });
        this.meta.entityUri = this.entity;
    }
}